// extracted by mini-css-extract-plugin
export var localeSelector = "_ae-0";